import { Component } from '@angular/core';
import { CorePageBaseComponent } from '../core-page-base.component';

@Component({
  selector: 'cu-dynamic-page-layout',
  templateUrl: './page-layout.component.html',
  standalone: false
})
export class PageLayoutComponent extends CorePageBaseComponent {}
